import Footer from "./Footer";
import Header from "./Header";

function Privacy() {
  return (
    <>
      <Header />

      <section className="bg-white">
        <div className="container py-5">
          <h1 className="display-5 font-bold mb-0 ls-sm">Privacy Policy</h1>

          <p className="mb-0 lh-sm">
            Welcome to <strong>Gorishtey.com</strong> (“we”, “our”, “us”). This
            Privacy Policy explains how we collect, use, and protect your
            personal information when you use our matrimonial and matchmaking
            services. By accessing or using our website and services, you agree
            to the practices described in this policy.
          </p>

          <h2 className="text-2xl font-semibold mt-3 mb-0">
            1. Information We Collect
          </h2>
          <p className="mb-0">
            We may collect the following information:
            <ul className="list-disc list-inside">
              <li>
                Personal details (name, age, gender, contact information, etc.).
              </li>
              <li>Profile information, preferences, and photographs.</li>
              <li>Payment and subscription details, if applicable.</li>
              <li>
                Usage data such as login history, IP address, and device
                information.
              </li>
            </ul>
          </p>

          <h2 className="text-2xl font-semibold mt-3 mb-0">
            2. How We Use Your Information
          </h2>
          <p className="mb-0">
            Your information is used to:
            <ul className="list-disc list-inside">
              <li>
                Provide and improve our matchmaking and matrimonial services.
              </li>
              <li>Personalize your experience on Gorishtey.com.</li>
              <li>
                Communicate with you regarding account, subscription, or
                support.
              </li>
              <li>Ensure security and prevent fraudulent activity.</li>
            </ul>
          </p>

          <h2 className="text-2xl font-semibold mt-3 mb-0">
            3. Sharing Your Information
          </h2>
          <p className="mb-0">
            We respect your privacy and do not sell your personal information.
            However, we may share information with:
            <ul className="list-disc list-inside">
              <li>Other users of Gorishtey.com for matchmaking purposes.</li>
              <li>
                Service providers and partners assisting us in delivering
                services.
              </li>
              <li>Authorities or legal entities as required by law.</li>
            </ul>
          </p>

          <h2 className="text-2xl font-semibold mt-3 mb-0">4. Data Security</h2>
          <p className="mb-0">
            We implement reasonable technical and organizational measures to
            protect your information from unauthorized access, use, or
            disclosure. However, no method of transmission over the internet or
            electronic storage is 100% secure, and we cannot guarantee absolute
            security.
          </p>

          <h2 className="text-2xl font-semibold mt-3 mb-0">
            5. Cookies and Tracking
          </h2>
          <p className="mb-0">
            We may use cookies and similar technologies to enhance your
            experience, analyze trends, and track usage patterns. You can
            disable cookies in your browser settings, but this may affect
            certain functionalities of our website.
          </p>

          <h2 className="text-2xl font-semibold mt-3 mb-0">6. Your Rights</h2>
          <p className="mb-0">
            You have the right to:
            <ul className="list-disc list-inside">
              <li>Access, update, or delete your personal information.</li>
              <li>Restrict or object to certain data processing.</li>
              <li>Withdraw consent to use your information at any time.</li>
            </ul>
          </p>

          <h2 className="text-2xl font-semibold mt-3 mb-0">
            7. Third-Party Links
          </h2>
          <p className="mb-0">
            Our website may contain links to third-party websites. We are not
            responsible for the privacy practices or content of these external
            websites. We encourage you to review the privacy policies of any
            third-party services you access.
          </p>

          <h2 className="text-2xl font-semibold mt-3 mb-0">
            8. Changes to Privacy Policy
          </h2>
          <p className="mb-0">
            We reserve the right to update or modify this Privacy Policy at any
            time. The updated policy will be posted on this page, and your
            continued use of Gorishtey.com constitutes acceptance of the
            changes.
          </p>

          <p className="mt-4 text-danger fst-italic fs-4">
            If you have any questions about this Privacy Policy, please contact
            us at <strong>support@gorishtey.com</strong>.
          </p>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Privacy;
